import React, { useCallback, useEffect, useState } from "react";
import { Spin, Select, Checkbox, Form, Button, Table, Image, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getGenderCategory } from "../../redux/actions/genderCategory.action";
import { getProductStatus } from "../../redux/actions/productStatus.actions";
import { getProductClass } from "../../redux/actions/productClass.action";
import { getFitCategory } from "../../redux/actions/fitCategory.action";
import { getProductType } from "../../redux/actions/productType.action";
import { getSeason } from "../../redux/actions/season.action";
import { getGender } from "../../redux/actions/gender.action";
import { getSize } from "../../redux/actions/size.action";
import { getSku } from "../../redux/actions/sku.action";
import { ReadCookie } from "../../utils/readCookie";
import { getWashName } from "../../redux/actions/wash.action";
import { getStyle } from "../../redux/actions/style";
import moment from "moment";
import btnPrint from "../../assets/images/button_print.gif";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import logo from "../../assets/images/logo.png";
import "../Distributor/Distributor.css";
import { Link } from "react-router-dom";
import Loader from "react-loader-spinner";
import { TabTitle } from "../../utils/GeneralFunction";
import { CSVLink } from "react-csv";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { getSeasonYear } from "../../redux/actions/seasonYear.action";
import { imediateOtsBySize } from "../../redux/actions/omsStockSummary2.action";
import { getskuloopUpData } from "../../redux/actions/skuLookupData.action";
import { useRef } from "react";
import { getBrands } from "../../redux/actions/brand.action";
import { sorterHelper } from "../../utils/filterHelper";
import { currencySymbol } from "../../utils/constants";
import { BASEURL } from "../../constant/config";
import axios from "axios";
import { saveAs } from "file-saver";
import { sizeChartHelper } from "../ImediateOtsBySize3/ImediateOtsBySize3";

const TotalOts = ({ token, userRights }) => {
  TabTitle("Total OTS");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const {
    style,
    gender,
    genderCategory,
    season,
    productStatus,
    wash,
    skuLookUpData,
    genderCategoryChange,
    styleChange,
    Sku,
    brand,
  } = useSelector((state) => state);

  const menuId = userRights.col_menu_id;
  const userName = ReadCookie("name");
  const [isChecked2, setIsChecked2] = useState([]);
  const [allStatus, setAllStatus] = useState(true);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const [filters, setFilters] = useState([]);
  const location = useLocation();
  const tableRef = useRef(null);
  const [isGenerate, setIsGenerate] = useState("All");
  const [isSKU, setIsSKU] = useState("All");

  const values = {
    item_id: null,
    location_id: null,
  };

  const { Option } = Select;

  const statusSelectAll = (e) => {
    setAllStatus(e.target.checked);
  };

  const isCheckboxChecked2 = (id, value) => {
    const filterCheckBox =
      productStatus &&
      productStatus?.payload?.data.find((val) => val.product_status_id === id);
    const checkId = isChecked2.includes(id);
    if (!checkId) {
      setIsChecked2((current) => [
        ...current,
        filterCheckBox.product_status_id,
      ]);
    }
    if (!value) {
      const removeUnCheck = isChecked2.filter(
        (item) => item !== filterCheckBox.product_status_id
      );
      setIsChecked2(removeUnCheck);
    }
    setAllStatus(false);
  };

  useEffect(() => {
    if (location?.state && location?.state?.values?.new_season_id) {
      const values = {
        as_on_date: moment("12-31-2023"),
        sku: "",
        season_id: location?.state?.values?.new_season_id,
        gender_id: location?.state?.values?.gender_id,
        gender_category_id: null,
        fit_category_id: null,
        style_id: null,
        product_status_id: null,
        product_class_id: null,
        sort_on: null,
        include_bgrade: "abc",
        wash_id: null,
      };
      form.setFieldsValue({
        season_id: values.season_id,
        gender_id: values.gender_id,
      });
      setLoading(true);
      dispatch(
        imediateOtsBySize(
          token,
          values,
          [],
          isChecked2,
          [],
          false
        )
      ).then((res) => {
        setLoading(false);
        setData(res?.payload?.data);
        // downloadExcelFileData(res?.payload?.data);
      });
    }
  }, [location?.state && location?.state?.values?.new_season_id]);

  const onFinish = async (e) => {
    form.setFieldsValue({
      gender_id: isGenerate,
      sku: isSKU
    });
    await form.validateFields().then((values) => {
      values.stepsChecked = [];
      values.isChecked = [];
      values.isChecked2 = isChecked2;
      if (allStatus) {
        values.allStatus = allStatus;
      }
      const distributorParam = {
        season_id: values.season_id === "All" ? null : values.season_id,
        sku: isSKU === "All" ? null : isSKU,
        gender_category_id: values.type === "All" ? null : values.type,
        style_id: values.style_id === "All" ? null : values.style_id,
        product_status_id: isChecked2.length > 0 ? isChecked2.toString() : null,
        pending_date: moment(values.as_on_date).format("YYYY-MM-DD"),
        as_on_date: moment(values.as_on_date).format("YYYY-MM-DD"),
        category_id:
          values.gender_category_id === "All"
            ? null
            : values.gender_category_id,
        fit_category_id: null,
        gender_id: isGenerate === "All" ? null : isGenerate,
        product_class_id: null,
        sort_on: null,
        include_bgrade: "abc",
        wash_id: values.wash_id === "All" ? null : values.wash_id,
        brand_id: values.brand_id === "All" ? null : values.brand_id,
        new_sesaon_year_id:
          values.new_season_year_id === "All"
            ? null
            : values.new_season_year_id,
      };
      setLoading(true);
      dispatch(getskuloopUpData(token, distributorParam)).then((res) => {
        setLoading(false);
        setData(res?.payload?.data);
      });
    });
  };

  const notificationKey = `open${Date.now()}`;
  const load = <div className="d-flex"><span className="spin-color mx-2">
    <Spin size="small" />
  </span><p>Please wait for a few minutes</p></div>;

  const handleDownload = async () => {
    try {
      // form.setFields("gender_id",isGenerate)
      notification.open({
        message: "Preparing Excel Download...",
        description: load,
        key: notificationKey,
        duration: 0,
      });

      form.setFieldsValue({
        gender_id: isGenerate,
        sku: isSKU
      });
      await form.validateFields().then(async (values) => {
        const distributorParam = {
          location_id: 1,
          season_id: values.season_id === "All" ? null : values.season_id,
          sku: isSKU === "All" ? null : isSKU,
          gender_category_id: values.type === "All" ? null : values.type,

          style_id: values.style_id === "All" ? null : values.style_id,
          product_status_id: isChecked2.length > 0 ? isChecked2.toString() : null,
          pending_date: moment(values.as_on_date).format("YYYY-MM-DD"),
          as_on_date: moment(values.as_on_date).format("YYYY-MM-DD"),
          category_id:
            values.gender_category_id === "All"
              ? null
              : values.gender_category_id,
          fit_category_id: null,
          gender_id: isGenerate === "All" ? null : isGenerate,
          gender_category_id: null,
          product_class_id: null,
          sort_on: null,
          include_bgrade: "abc",
          wash_id: values.wash_id === "All" ? null : values.wash_id,
          brand_id: values.brand_id === "All" ? null : values.brand_id,
          new_sesaon_year_id:
            values.new_season_year_id === "All"
              ? null
              : values.new_season_year_id,
        };
        const key = "total_ots"
        const response = await axios.post(`${BASEURL}getAll/DownloadSkuLookupData`, { distributorParam, filters, key }, {
          responseType: "blob", // Important!
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const blob = new Blob([response.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "Total-OTS.xlsx");

        notification.destroy({ key: notificationKey });
        notification.success({
          message: "Download Successful",
          description: "Your Excel report has been downloaded.",
          className: "toast-success",
        });
      });
    } catch (error) {
      // Destroy loader and show error notification
      notification.destroy({ key: notificationKey });
      notification.error({
        message: "Download Failed",
        description: "Something went wrong while downloading the Excel report.",
        className: "toast-error",
      });
    }
  };

  useEffect(() => {
    dispatch(getStyle(token, menuId));
    dispatch(getProductType(token, values));
    dispatch(getGenderCategory(token, menuId));
    dispatch(getSeason(token, menuId));
    dispatch(getProductStatus(token, menuId));
    dispatch(getProductClass(token, menuId));
    dispatch(getSize(token, menuId));
    dispatch(getGender(token, menuId));
    dispatch(getFitCategory(token, menuId));
    dispatch(getWashName(token, menuId));
    dispatch(getSeasonYear(token, menuId));
    dispatch(getBrands(token));
  }, [dispatch, menuId, token]);

  useEffect(() => {
    if (allStatus) {
      setIsChecked2([]);
    }
  }, [allStatus]);

  const handlePrint = () => {
    window.print();
  };

  const handleGender = (gender_id) => {
    form.setFieldsValue({
      gender_category_id: "All",
      style_id: "All",
      sku: "All",
    });
  };

  const handleStyle = (gender_category_id) => {
    form.setFieldsValue({
      style_id: "All",
      sku: "All",
    });
  };

  const handleSku = (sku_id) => {
    if (sku_id === null) {
      dispatch(getSku(token, null, null, null));
    } else {

    }
    form.setFieldsValue({
      sku: "All",
    });
  };

  function debounce(cb, delay = 1000) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  }

  const handleSkuSearch = () => {
    dispatch(getSku(token, null, null, null));
  };

  const optimizedFn = useCallback(debounce(handleSkuSearch), []);


  let sizeChartRendering = form.getFieldValue("gender_id")
  let sizeChartRenderingSKU = form.getFieldValue("sku")

  const colums = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: 40,
      render: (text, record, index) => {
        return index + 1;
      },
    },
    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",
      render: (text, record) => {
        return (
          <Link
            style={{
              color: "blue",
              textDecoration: "underline",
            }}
            to={{
              pathname: `/sku-lookup?sku=${record.sku}`,
              state: data,
            }}
            target="_blank"
          >
            {record.sku}
          </Link>
        );
      },
      ...sorterHelper("sku", "num")
    },
    {
      title: "Inseam",
      dataIndex: "inseam",
      key: "inseam",
      ...sorterHelper("inseam", "num")
    },
    {
      title: "Style",
      dataIndex: "style_name",
      key: "style_name",
      ...sorterHelper("style_name")
    },
    {
      title: "Wash",
      dataIndex: "wash_name",
      key: "wash_name",
      ...sorterHelper("wash_name")
    },
    {
      title: "Current Season",
      dataIndex: "current_season",
      key: "current_season",
      ...sorterHelper("current_season")
    },
    {
      title: "Gender",
      dataIndex: "gender_name",
      key: "gender_name",
      ...sorterHelper("gender_name")
    },
    {
      title: "Fit Category",
      dataIndex: "fit_category_name",
      key: "fit_category_name",
      ...sorterHelper("fit_category_name")
    },
    {
      title: "Brand",
      dataIndex: "brand_name",
      key: "brand_name",
      ...sorterHelper("brand_name")
    },
    {
      title: "WS",
      dataIndex: "ws",
      key: "ws",
      align: "right",
      ...sorterHelper("ws", "num")
    },
    {
      title: "RTL",
      dataIndex: "rtl",
      key: "rtl",
      align: "right",
      ...sorterHelper("rtl", "num")
    },
    ...(sizeChartHelper(sizeChartRendering, sizeChartRenderingSKU, skuLookUpData, filters)),
    {
      title: "Total",
      align: "right",
      className: "border-z-index-1",
      render: (text, record) => {
        return (
          <>
            {Number(record.all_locations.final_ots)}
          </>
        );
      },
      sorter: (a, b) => {
        return a.all_locations.final_ots - b.all_locations.final_ots;
      },
    },
    {
      title: "Image",
      dataIndex: "image_url",
      key: "image_url",
      width: 50,
      render: (text, record) => (
        <div className="image-nu">
          <Image src={text} />
        </div>
      ),
    }
  ];

  return (
    <div className="header_class business_header_oms">
      <div className="row justify-content-between business_class_oms distributor">
        <div className="col-3 d-flex align-items-start box-space">
          <div className="logobrand">
            <img id="ImgLogo" alt="logo" src={logo} />
          </div>
        </div>
        <div className="col-4 box-space right-content-header text-right">
          <div className=" d-flex justify-content-end">
            <div className=" d-flex justify-content-end mr-8">
              <div className="print_icon printing_class">
                <i
                  onClick={handlePrint}
                  id="Image1"
                  title="Print"
                  alt="Print"
                  src={btnPrint}
                  className="fa-solid fa-print"
                ></i>
              </div>
              <div className="print_icon printing_class" onClick={handleDownload}>
                {/* <CSVLink
                  filename={"Total-OTS.csv"}
                  data={excelData}
                  onClick={downloadExcelFileData}
                  style={{ display: "flex" }}
                > */}
                <input
                  type="image"
                  name="ImgExcel"
                  alt="Export to excel"
                  id="ImgExcel"
                  title="Export to excel"
                  src={xlsx}
                  height={14}

                />
                {/* </CSVLink> */}
              </div>
            </div>
            <span style={{ fontSize: "small", fontWeight: "bolder" }}>
              Total OTS
              <br />
              Rpt # 489
              <br />
              <p className=" mb-0">Rpt # 001_V4</p>
              Login as:{" "}
              <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                {userName}
              </span>
            </span>
          </div>
        </div>
      </div>

      <div className="business_class_oms mb-2 distributor">
        <Form form={form} name="control-hooks" onFinish={onFinish}>
          <div className="main_form row">
            <div className="col-12">
              <hr className="my-1" />
              <div>
                <label htmlFor="">Product Status</label>
                <div className="checkboxes">
                  <div className="checkbox_content">
                    <Form.Item name="current_status_id" className=" mb-0">
                      <Checkbox checked={allStatus} onChange={statusSelectAll}>
                        All
                      </Checkbox>
                    </Form.Item>
                  </div>
                  {productStatus &&
                    productStatus?.payload?.data.map((it, index) => {
                      return (
                        <div key={index} className="checkbox_content">
                          <Form.Item name="current_status_id">
                            <Checkbox
                              checked={
                                allStatus
                                  ? false
                                  : isChecked2.includes(it.product_status_id)
                              }
                              onChange={(e) =>
                                isCheckboxChecked2(
                                  it.product_status_id,
                                  e.target.checked
                                )
                              }
                            >
                              {it.product_status_name}
                            </Checkbox>
                          </Form.Item>
                        </div>
                      );
                    })}
                </div>
              </div>
              <hr className="my-1" />
              <div className="main_form row">
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Gender
                    </label>
                    <div className="w-100">
                      {/* <Form.Item name="gender_id" initialValue={"All"}> */}
                      <Select
                        className={"select_Inputs"}
                        showSearch
                        optionFilterProp="children"
                        size="small"
                        defaultValue={"All"}
                        onChange={(e) => {
                          console.log("eeeeeeeeeee", e);
                          setIsGenerate(e);
                        }}
                      >
                        <Option value={null}>All</Option>
                        {gender &&
                          gender?.payload?.data.map((it, index) => {
                            return (
                              <Option key={index} value={it.gender_name}>
                                {it.gender_name}
                              </Option>
                            );
                          })}
                      </Select>
                      {/* </Form.Item> */}
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Season
                    </label>
                    <div className=" w-100">
                      <Form.Item name="season_id" initialValue={"All"}>
                        <Select
                          defaultValue={form.getFieldValue().season_name}
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          filterSort={(optionA, optionB) =>
                            optionB?.value !== null ?
                              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                          }
                        >
                          <Option value={null}>All</Option>
                          {season &&
                            season?.payload?.data?.map((status, index) => {
                              return (
                                <Option key={index} value={status.season_name}>
                                  {status.season_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Wash
                    </label>
                    <div className="w-100">
                      <Form.Item name="wash_id" initialValue={"All"}>
                        <Select
                          defaultValue={form.getFieldValue().wash_name}
                          className={"select_Inputs"}
                          showSearch

                          optionFilterProp="children"
                          size="small"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          filterSort={(optionA, optionB) =>
                            optionB?.value !== null ?
                              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                          }
                        >
                          <Option value={null}>All</Option>
                          {wash &&
                            wash?.payload?.data?.map((status, index) => {
                              return (
                                <Option key={index} value={status.wash_name}>
                                  {status.wash_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                {/*Second*/}
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Category
                    </label>
                    <div className="w-100">
                      <Form.Item initialValue={"All"} name="gender_category_id">
                        <Select
                          className={"select_Inputs"}
                          showSearch

                          optionFilterProp="children"
                          size="small"
                          onChange={(e) => handleStyle(e)}
                          filterSort={(optionA, optionB) =>
                            optionB?.value !== null ?
                              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                          }
                        >
                          <Option value={null}>All</Option>
                          {genderCategoryChange &&
                            genderCategoryChange?.payload?.data.length >= 0
                            ? genderCategoryChange &&
                            genderCategoryChange?.payload?.data.map(
                              (it, index) => {
                                return (
                                  <Option
                                    key={index}
                                    value={it.gender_category_name}
                                  >
                                    {it.gender_category_name}
                                  </Option>
                                );
                              }
                            )
                            : genderCategory &&
                            genderCategory?.payload?.data.map((it, index) => {
                              return (
                                <Option
                                  key={index}
                                  value={it.gender_category_name}
                                >
                                  {it.gender_category_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </div>
              <div className="main_form row form-margin">
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Sku
                    </label>
                    <div className="w-100">
                      {/* <Form.Item name="sku" initialValue={"All"}> */}
                      <Select
                        notFoundContent={
                          Sku.loading ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Loader
                                type="Oval"
                                color="#3c4b58"
                                height={20}
                                width={20}
                              />
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                              }}
                            >
                              No Data
                            </div>
                          )
                        }
                        className={"select_Inputs"}
                        showSearch
                        onSearch={(value) => {
                          optimizedFn(value);
                        }}
                        onChange={(e) => {
                          console.log("eeeeeeeeeee", e);
                          setIsSKU(e);
                        }}
                        defaultValue={"All"}
                        optionFilterProp="children"
                        size="small"
                      >
                        <Option value="All">All</Option>
                        {Sku &&
                          Sku?.payload?.data.map((it, index) => {
                            return (

                              <Option key={index} value={it.sku}>
                                {it.sku}
                              </Option>
                            );
                          })}
                      </Select>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Style
                    </label>
                    <div className="w-100">
                      <Form.Item initialValue={"All"} name="style_id">
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          onChange={(e) => handleSku(e)}
                          filterSort={(optionA, optionB) =>
                            optionB?.value !== null ?
                              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                          }
                        >
                          <Option value={null}>All</Option>
                          {styleChange && styleChange?.payload?.data.length >= 0
                            ? styleChange &&
                            styleChange?.payload?.data.map((style, index) => {
                              return (
                                <Option key={index} value={style.style_name}>
                                  {style.style_name}
                                </Option>
                              );
                            })
                            : style &&
                            style?.payload?.data.map((style, index) => {
                              return (
                                <Option key={index} value={style.style_name}>
                                  {style.style_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Brand
                    </label>
                    <div className="w-100">
                      <Form.Item initialValue={"All"} name="brand_id">
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          onChange={(e) => handleSku(e)}
                          filterSort={(optionA, optionB) =>
                            optionB?.value !== null ?
                              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                          }
                        >
                          <Option value="All">All</Option>
                          {brand &&
                            brand?.payload?.data.map((item, index) => {
                              return (
                                <Option key={index} value={item.brand_id}>
                                  {item.brand_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: "3px",
                      float: "right",
                    }}
                  >
                    <Button
                      style={{ width: "fit-content" }}
                      type="primary"
                      htmlType="submit"
                      className="submit-btn-btm m-0"
                    >
                      Generate
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <div >
        <div className="overflow"
          style={{
            overflowY: "scroll",
          }}>
          {skuLookUpData?.payload?.data !== undefined ? (
            data.length > 0 ? (
              <Table
                className="fix-scroll-table  table-header-sticky  border-line-th  bottom-align-th  table-td-border-right  th-general-style  
              td-general-style even-tr-style border"
                ref={tableRef}
                size="small"
                bordered={false}
                type="company"
                headerClassName="abc"
                dataSource={data}
                columns={colums}
                loading={skuLookUpData.loading}
                pagination={{
                  defaultCurrent: 1,
                  defaultPageSize: 50,
                  pageSizeOptions: [100, 200, 500],
                }}
                scroll={{ x: "max-content" }}
              />
            ) : (
              <div className="no-Data">
                <h1>No Data</h1>
              </div>
            )
          ) : (
            loading && (
              <div className="loader" style={{ marginTop: "20px" }}>
                <Spin size="medium" />
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default TotalOts;
